function ABPAS_MPGARUD() {
  return (
    <div>
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src="/ABPASS.html" // your HTML file in public folder
          title="MP Garud KML Map"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default ABPAS_MPGARUD;
